export default __webpack_public_path__ + "static/media/tether.0af4186a.png";